import { PrimaryPinkButton } from 'components/buttons/PrimaryPinkButton';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import dayjs from 'dayjs';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { UiActions } from 'state/actions/UiActions';

import styles from './styles.module.scss';

export class GlamstarChallengeDetail extends Component {
  constructor(props) {
    super(props);
    const { match, location } = this.props;
    this.campaignId = match.params?.id;
    this.canAccess = location.state?.canAccess;

    this.state = {
      videos: [],
      challenge: null,
    };
  }

  currentDateIsAfterDateTo = dateTo => {
    return dayjs().isAfter(dateTo, 'days');
  };

  getCampaign = async () => {
    this.props.loaderShow();
    await ExecuteRequest(
      GlamboxEndpoints.Campaign.getByIdWithoutDetail,
      null,
      'GET',
      { Authorization: this.props.token },
      {
        campaignId: this.campaignId,
      },
      response => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          this.setState({
            challenge: result,
            videos: [
              {
                title: 'VÍDEO TESTE 1',
                url: 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22190.mp4',
              },
              { 
                title: 'VÍDEO TESTE 2',
                url: 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22191.mp4',
              }
            ],
          });
        } else {
          this.props.publishErrorAlert('Houve um erro ao carregar os desafio');
        }
        this.props.loaderHide();
      }
    );
  };

  componentDidMount() {
    const { history } = this.props;

    if (!this.canAccess) {
      history.push('/glampartner/glamstar/desafios');
      return;
    }

    this.getCampaign();
  }

  render() {
    const { videos, challenge } = this.state;

    if (!challenge) {
      return null;
    }

    const challengeClosed = this.currentDateIsAfterDateTo(challenge.dateTo);

    let currentChallenge = {
      ...challenge,
      dateFrom: new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
      }).format(new Date(challenge.dateFrom)),
      dateTo: new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
      }).format(new Date(challenge.dateTo)),
    };

    return (
      <div className={styles.container}>
        <header className={styles.concurseHeader}>
          <h1 className={styles.concurseTitle}>{currentChallenge.title}</h1>
          <span className={styles.concurseTime}>
            Prazo: <time>{currentChallenge.dateFrom}</time> até{' '}
            <time>{currentChallenge.dateTo}</time>
          </span>
        </header>

        <main className={styles.hero}>
          <div className={styles.challengeWrapper}>
            <video className={styles.currentChallengeVideo} controls>
              <source
                src="https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22189.mp4"
                type="video/mp4"
              />
            </video>
          </div>

          <section className={styles.rules}>
            <h2 className={styles.rulesTitle}>Missão</h2>
            <div className={styles.rulesContent}>
              <p className={styles.paragraph}>
                No challenge <strong>"Glambox Quiz"</strong> a sua missão <strong>é explicar a diferença entre as assinaturas</strong> do nosso Clube Glambox, mostrando que temos opções de assinatura para todos os gostos e bolsos. Todas as assinaturas dão acesso a todos os benefícios do Clube como os descontos adicionais na Loja, troca de Glampoints por produtos, e muitos outros.              </p>
              <div className={styles.rulesContent}>
              <ul className={styles.rulesListDisc}>
                <p className={styles.paragraph}>As diferenças entre cada tipo de assinatura são:</p>
                <li>
                  <strong>Glambox</strong> - caixinha linda todo mês, com 5 a 7 produtos que valem mais de R$240. A partir de R$74,90/mês.
                </li>
                <li>
                  <strong>Glambag</strong> - bag incrível todo mês, com 3 a 5 produtos que valem mais de R$100. A partir de R$39,90/mês no plano anual.
                </li>
                <li>
                  <strong>Glampass</strong> -  o passe mágico para todos os benefícios do Clube e compra avulsa da box e da bag sempre que quiser. A partir de R$9,90/mês. Com o Glampass, as assinantes podem comprar <strong>mais de 6 mil produtos de beleza com os melhores preços do Brasil</strong> e descontos adicionais de até 60% na Loja, ganhar Glampoints para trocar produtos e fazer parte da maior comunidade de beleza, tendo acesso a conteúdos exclusivos!.
                </li>
              </ul>
            </div>
            <p className={styles.paragraph}>É sua hora de mostrar que é uma verdadeira expert no nosso Clube! Não esqueça de <strong>divulgar seu cupom</strong> para trazer ainda mais Glamgirls para a Glambox.</p>
            </div>
          </section>
          <br />

          <section className={styles.rules}>
            <h2 className={styles.rulesTitle}>Benefícios para se tornar uma influencer de sucesso</h2>
            <div className={styles.rulesContent}>
              <ul className={styles.rulesListDisc}>
                <li>
                  Os <strong>2 melhores vídeos</strong> serão publicados nas redes sociais da Glambox  (TikTok, Instagram e/ou  YouTube) e  impulsionados com mídia no nosso Instagram para que você tenha ainda mais audiência no seu perfil!
                </li>
              </ul>
              <p className={styles.paragraph}>
                <strong>Desenhamos todas essas divulgações para te ajudar a ganhar ainda mais destaque nas suas redes sociais e ainda mais seguidoras, te ajudando a virar uma influencer de sucesso!</strong>
              </p>
            </div>
          </section>
        <br />
          <section className={styles.rules}>
            <h2 className={styles.rulesTitle}>Regras</h2>
            <div className={styles.rulesContent}>
              <ol className={styles.rulesList}>
                <li>
                  Realizar o vídeo seguindo a missão proposta, contendo a diferença dos TRÊS tipos de assinaturas da Glambox
                </li>
                <li>
                  Ter no máximo 1 minuto.
                </li>
                <li>
                  Marcar @glamboxbrasil, além de usar a hashtag #Glamstar2022 #GlamboxQuiz 
                </li>
              </ol>
              <br />

              <strong className={styles.rulesInfo}>Formato</strong>
              <p className={styles.rulesDescription}>
                Publique seu vídeo em todas as suas redes sociais: YouTube, Instagram e TikTok, garantindo mais visualizações e engajamento para o seu challenge. Levaremos isso em consideração em sua avaliação!
              </p>
              <p className={styles.rulesDescription}>
                Seja criativa, e <strong>explore transições, áudios que estão bombando e não esqueça de mostrar a variedade de planos que temos na Glambox</strong>. Isso vai ajudar você a se destacar na competição e garantir uma das 4 vagas para a final do Glamstar!
              </p>
              <ul className={styles.rulesListDisc}>
                  <p className={styles.rulesDescription}>  
                    Dedique-se na edição, esperamos uma alta qualidade de uma Glampartner como você! 
                      <br />
                        Lembre-se de:
                  </p>
                  <li>
                    Prepare um roteiro para seu challenge;
                  </li>
                  <li>
                    Arrume um bom cenário com luz e enquadramentos bons;
                  </li>
                  <li>
                    Capriche na edição e garanta bom áudio;   
                  </li>
                  <li>
                    USAR TODA SUA CRIATIVIDADE!
                  </li>
                </ul>
              <strong className={styles.rulesInfo}>Prazo de envio</strong>
                <p className={styles.rulesDescription}>
                  Publique o seu vídeo em suas redes sociais e não se esqueça de enviá-lo pelo portal até o dia <strong>13/09/2022</strong>. Mas lembre-se que quanto antes você publicar, mais tempo terá de bombar seu número de visualizações até a data da avaliação! 
                </p>
              <ul className={styles.rulesListDisc}>
                <strong className={styles.rulesInfo}>
                  Critérios de avaliação
                </strong>
                <li>
                  Sua capacidade de cumprir de maneira clara e criativa os objetivos desse vídeo.
                </li>
                <li>
                  A qualidade técnica de seu vídeo. Esteja atenta a iluminação, áudio e edição.
                </li>
                <li>
                  O respeito de todas as regras do challenge.
                </li>
                <li>
                  A quantidade de views somados de todas as plataformas em que você postar o vídeo.
                </li>
                <li>
                  Sua participação em todo o concurso. Quanto mais challenges participar, maior sua relevância no Glamstar.
                </li>
                <li>
                  Mostrar que você é uma expert em Glambox e que sabe tudo sobre as nossas assinaturas, explicando todas as diferenças entre elas para suas seguidoras!
                </li>
              </ul>
            </div>
          </section>

          <Link
            className={styles.sendChallenge}
            to={{
              pathname: `/glampartner/glamstar/desafio/form/${this.campaignId}`,
              state: { canAccess: this.canAccess },
            }}
          >
            <PrimaryPinkButton disabled={challengeClosed}>
              Enviar Challenge
            </PrimaryPinkButton>
          </Link>

          <section className={styles.challengesExample}>
            <h2 className={styles.challengeExampleTitle}>Vídeos de exemplo</h2>
            <p className={styles.paragraph}>
              Nosso time preparou alguns exemplos de vídeos para te ajudar a se soltar! Capriche muito na sua produção.
            </p>
            <div className={styles.videosExample}>
              {videos?.length > 0 &&
                videos.map(video => (
                  <video key={video.title} controls>
                    <source src={video.url} type="video/mp4"></source>
                  </video>
                ))}
            </div>
          </section>
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  store: state,
  token: state.token.data.Authorization,
});

const mapDispatchToProps = dispatch => ({
  publishSuccessAlert: message => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: message => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
});

GlamstarChallengeDetail = connect(
  mapStateToProps,
  mapDispatchToProps
)(GlamstarChallengeDetail);
